import { render, staticRenderFns } from "./edit-users.vue?vue&type=template&id=294b4c45&"
import script from "./edit-users.vue?vue&type=script&lang=js&"
export * from "./edit-users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports